export const stationZh = {
  // 标题
  title: '工位',
  management: '工位管理',
  list: '工位列表',
  create: '新建工位',
  edit: '编辑工位',
  detail: '工位详情',

  // 字段
  code: '工位代码',
  nameEn: '英文名称',
  nameCn: '中文名称',
  description: '描述',
  area: '区域/车间',
  line: '产线',
  type: '工位类型',
  status: '状态',
  sortOrder: '排序',
  partsCount: '零件数量',
  createdAt: '创建时间',
  updatedAt: '更新时间',

  // 状态
  statusOptions: {
    ACTIVE: '启用',
    INACTIVE: '停用',
    MAINTENANCE: '维护中',
  },

  // 占位符
  placeholder: {
    code: '请输入工位代码',
    nameEn: '请输入英文名称',
    nameCn: '请输入中文名称',
    description: '请输入描述',
    area: '请选择或输入区域',
    line: '请选择或输入产线',
    type: '请选择或输入类型',
    search: '搜索工位代码或名称...',
  },

  // 操作
  actions: {
    create: '新建工位',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    import: '批量导入',
    export: '导出',
    downloadTemplate: '下载模板',
  },

  // 消息
  messages: {
    loadFailed: '加载工位列表失败',
    createSuccess: '工位创建成功',
    createFailed: '工位创建失败',
    updateSuccess: '工位更新成功',
    updateFailed: '工位更新失败',
    deleteSuccess: '工位删除成功',
    deleteFailed: '工位删除失败',
    deleteConfirm: '确定要删除工位 {code} 吗？',
    hasPartsError: '该工位下有零件，无法删除',
    codeExists: '工位代码已存在',
    importSuccess: '导入成功 {count} 条',
    importFailed: '导入失败 {count} 条',
    importPartialSuccess: '成功导入 {success} 条，失败 {failed} 条',
  },

  // 导入
  import: {
    title: '批量导入工位',
    description: '上传 CSV 文件批量导入工位',
    downloadTemplate: '下载模板',
    selectFile: '选择文件',
    uploading: '导入中...',
    result: '导入结果',
    success: '成功',
    failed: '失败',
    errors: '错误详情',
    row: '行',
    errorMessage: '错误信息',
  },

  // 筛选
  filter: {
    all: '全部',
    allAreas: '全部区域',
    allLines: '全部产线',
    allTypes: '全部类型',
    allStatus: '全部状态',
  },

  // 空状态
  empty: {
    title: '暂无工位',
    description: '点击上方按钮创建第一个工位',
  },

  // 表格
  table: {
    code: '代码',
    name: '名称',
    area: '区域',
    line: '产线',
    type: '类型',
    status: '状态',
    partsCount: '零件数',
    actions: '操作',
  },
};

